<template>
  <div class="py-4 container-fluid">
    <div class="row mt-4">
      <div class="col-md-6 offset-md-3">
        <div class="quad px-3 py-2 text-center pt-6 pb-5">
          <h1>Validação feita com sucesso. O novo Code já foi salvo!</h1>
          <button class="btn btn-success h3" @click="fecharJanela()">
            Fechar Janela
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
//import { useRouter } from "vue-router";
export default {
  setup() {
    const storage = useStorage();
    const router = useRouter();
    var token = storage.getStorageSync("token");

    const state = reactive({
      usuarios: [],
    });
    onMounted(() => {
      if (router.currentRoute._value.query.code) {
        state.code = router.currentRoute._value.query.code;
        salvarCode();
      }
    });

    async function salvarCode() {
      await services.configuracao
        .salvarCode({
          code: state.code,
          token,
        })
        .then((response) => {
          console.log(response);
        });
    }
    function fecharJanela() {
      window.close();
    }
    return {
      state,
      fecharJanela,
    };
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap");

.content {
  padding: 4rem;
}

.card {
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  height: 140px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  border: solid 1px #0000000d;
}

.card #icon_card {
  width: 60px;
  height: 60px;
  margin-right: 15px;
  object-fit: contain;
}

.info p {
  margin-bottom: 0;
  color: #787878;
  font-size: 18px;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
}

.info h3 {
  margin-bottom: 0;
  color: #001942;
  font-size: 26px;
  font-weight: 700;
  font-family: "Poppins", sans-serif;
}

.coluna {
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  border: solid 1px #0000000d;
}

.coluna h2 {
  font-weight: 600;
  color: #001942;
  font-size: 24px;
  font-family: "Poppins", sans-serif;
  padding: 10px;
}

.coluna-itens {
  padding: 20px;
}

.item {
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  margin-bottom: 2rem;
}

.info2 {
  margin-left: 15px;
}

.info2 p {
  margin-bottom: 0;
  color: #787878;
  font-size: 18px;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
}

.info2 h3 {
  margin-bottom: 0;
  color: #001942;
  font-size: 26px;
  font-weight: 700;
  font-family: "Poppins", sans-serif;
}

.quad {
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  border: solid 1px #0000000d;
}

.quad h2 {
  font-weight: 600;
  color: #001942;
  font-size: 24px;
  font-family: "Poppins", sans-serif;
  padding: 10px;
  margin-bottom: 0;
}

.search {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  margin-right: 10px;
  margin-bottom: 1rem;
}

.search input {
  width: 100%;
  border: none;
  outline: none;
  padding: 10px;
  border-radius: 0 45px 45px 0;
  background: #f4f7fe;
}

.search input::placeholder {
  color: #9d9d9d;
}

.search .btn_search {
  border: none;
  outline: none;
  padding: 10px;
  border-radius: 45px 0 0 45px;
  background: #f4f7fe;
  color: #9d9d9d;
}

.table {
  border-radius: 6px;
  font-family: "Poppins", sans-serif;
}
</style>